import { getErrorMessageFromErrorType } from '@flowwai-frontend/shared/utils/common'
import { SendOtpForUpdatingUserPinMutation as Mutation } from './mutation.generatedTypes'

interface ResponseArgsType {
   data: Mutation

   onHandleError: (
      errorMessage: string,
      data: Mutation['sendOtpForUpdatingUserPin']
   ) => void

   onSuccess?: () => void
}

interface ReturnType {
   handleAPIResponse: (args: ResponseArgsType) => void
}

const useAPIResponseHandler = (): ReturnType => {
   const handleAPIResponse = (args: ResponseArgsType): void => {
      const { sendOtpForUpdatingUserPin } = args.data

      switch (sendOtpForUpdatingUserPin.__typename) {
         case 'SendOtpForUpdatingUserPinResult': {
            args.onSuccess?.()
            break
         }
         case 'NoRegisteredMobileNumber':
         default: {
            const errorType = sendOtpForUpdatingUserPin.__typename
            const errorMessage = getErrorMessageFromErrorType(errorType)

            args.onHandleError?.(errorMessage, sendOtpForUpdatingUserPin)
            break
         }
      }
   }

   return { handleAPIResponse }
}

export default useAPIResponseHandler
